export enum ParticipantConfirmationModalDataHooks {
  ROOT = 'participant-confirmation-modal',
}
